<template>
  <div class="el-section">
    <emd-card
      noBorder
      class="_footer_spaced_sm"
    >
      <slot name="header"></slot>
      <slot></slot>

      <section
        v-if="loadingListOrders"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader type="_invert" />
      </section>

      <section
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="items"
          :toDetail="detail"
        />

        <empty-list
          v-if="showEmptyList"
          entity="orders"
        />

        <empty-list-filter
          v-if="showEmptyListFilter"
          entity="orders"
        />
      </section>

      <pagination
        v-if="!loadingListOrders"
        type="list"
        :action="action"
        :pagination="pagination"
        :totalShowing="totalItems"
      ></pagination>
    </emd-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { EmdCard, EmdLoader } from 'emerald-vue/src/components'

import EmptyList from '@/components/project/globals/EmptyList.vue'
import EmptyListFilter from '@/components/project/globals/EmptyListFilter.vue'
import Table from '@/components/project/molecules/Table.vue'
import Pagination from '@/components/project/globals/Pagination.vue'

import { FIELDS } from './fields.enum'

export default {
  name: 'OrdersTable',

  components: {
    EmdCard,
    EmdLoader,
    EmptyList,
    EmptyListFilter,
    Table,
    Pagination
  },

  props: {
    action: {
      type: String,
      default: 'GET_ORDERS'
    }
  },

  data () {
    return {
      toDetail: {
        name: 'ordersDetail',
        params: {
          id: 'id'
        },
        query: ['created_at']
      }
    }
  },

  computed: {
    ...mapGetters(['orders', 'loadingListOrders', 'permissionIsEnabled']),

    fields () {
      return FIELDS.map(item => ({ ...item, type: this.typeField(item) }))
    },

    pagination () {
      return this.orders.pagination
    },

    items () {
      return this.orders.items
    },

    totalItems () {
      return this.items.length
    },

    detail () {
      if (this.permissionIsEnabled('order:get')) {
        return this.toDetail
      }
      return null
    },

    query () {
      const routeQuery = Object.assign({}, this.$route.query)
      delete routeQuery.date_filters
      delete routeQuery.period_type

      return routeQuery
    },

    emptyList () {
      return (
        !this.loadingListOrders &&
        this.pagination &&
        this.pagination.total_items === 0
      )
    },

    showEmptyList () {
      return this.emptyList && Object.keys(this.query).length <= 4
    },

    showEmptyListFilter () {
      return this.emptyList && Object.keys(this.query).length > 4
    }
  },

  methods: {
    typeField (item) {
      if (!item.permission) return item.type
      return this.permissionIsEnabled(item.permission) ? 'link' : 'text'
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "btn-create": "Criar pedido"
    },
    "en-US": {
      "btn-create": "Create order"
    }
  }
  </i18n>
